module.exports = __webpack_public_path__ + "img/icon_chn.6cf4941.png";